import React, { useEffect } from 'react';
import { useInjection } from 'inversify-react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import type { ImageSlicesListController } from '../imageSlicesList';
import type { SliceType } from '@/engine/app/modules/images/interfaces';
import { TYPES } from '@/engine/ioc';
import { SliceImageButton } from '../common/SliceImageButton';

interface ImageVisibilityButtonProps {
  descriptor: SliceType;
  isMaximized?: boolean;
}

export const ImageVisibilityButton: React.FC<ImageVisibilityButtonProps> = ({ descriptor, isMaximized }) => {
  const [isActive, setIsActive] = React.useState(false);
  const imageSlicesListController = useInjection<ImageSlicesListController>(TYPES.ImageSlicesListController);
  const currentImageSlice = imageSlicesListController.getImageSliceByType(descriptor);

  useEffect(() => {
    setIsActive(!!currentImageSlice?.isVisible);
  }, [currentImageSlice]);

  return (
    <SliceImageButton
      className={`images-visibility-icon ${descriptor}-visibilityTool ${isMaximized ? 'maximized' : 'minimized'}`}
      $isMaximized={isMaximized}
      $isActive={isActive}
      onClick={(): void => {
        imageSlicesListController.toggleImageSliceVisibilityByType(descriptor);
        setIsActive(currentImageSlice?.isVisible || false);
      }}
    >
      {currentImageSlice?.isVisible ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
    </SliceImageButton>
  );
};
